export type Snapshot = {
  data: () => any
}

export const getConverter = <T>(
  transpiler: (snapshot: Snapshot, data: any) => T = (snapshot, data) => {
    return {
      ...data,
    }
  }
) => {
  const converter = {
    toFirestore(data: T) {
      const { ...rest } = data
      return rest
    },
    fromFirestore(snapshot: Snapshot) {
      const data = snapshot.data()
      const value: T = transpiler(snapshot, data)
      return value
    },
  }
  return converter
}
